import { useMutation, useQueryClient } from '@tanstack/react-query';

import { notifyMeta } from '@/lib/notify';
import { STAFF_KEYS } from '@/constants/queryKeys';
import { authService } from '@/services/auth';
import { errorUtils } from '@/services/errors';

const useResetTotp = () => {
  const queryClient = useQueryClient();

  return useMutation<void, Error, void>({
    meta: notifyMeta('authTotpReset'),
    mutationFn: async () => {
      errorUtils.unwrap(await authService.resetTotp());

      await queryClient.invalidateQueries({ queryKey: STAFF_KEYS.root });
    },
  });
};

export {
  useResetTotp,
};
